var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path0, _g0, _path1, _g1, _path10, _g10, _path11, _g11, _path12, _g12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfomanav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 56,
    viewBox: "0 0 315 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 9,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.47073V52.4943H8.39909V9.61611C8.39909 7.8763 6.99353 6.47073 5.25372 6.47073H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.39909 6.47073H0V52.4943H8.39909V6.47073Z",
    fill: "url(#paint0_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 18,
    width: 31,
    height: 35
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.443 24.2202H24.2373L24.0659 22.129C23.9288 20.4921 22.5661 19.2408 20.9291 19.2408H16.4553C16.661 22.1119 16.7296 25.3173 16.7296 29.1397V52.4943H25.1972V32.9621C25.1972 32.0108 25.2658 30.9824 25.5401 30.2282C26.4314 27.6999 28.7454 25.3087 32.0965 25.3087C36.6731 25.3087 38.4472 28.9254 38.4472 33.7078V52.4857H46.8463V32.7479C46.8463 22.2319 40.8384 18.478 35.0362 18.478C29.2339 18.478 25.8829 21.6148 24.4516 24.2117",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8377 18.4813H16.4553V52.4891H46.8377V18.4813Z",
    fill: "url(#paint1_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 3,
    width: 24,
    height: 50
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0305 6.47073C58.1594 9.20472 57.0023 13.5071 57.0023 17.8009V19.2322H52.4943V25.5144H57.0023V52.4857H65.4014V25.5144H69.4895C71.2293 25.5144 72.6435 24.1002 72.6435 22.3604V19.2322H65.3329V17.5267C65.3329 13.43 66.7641 9.95035 70.9294 9.95035C72.4292 9.95035 73.5948 10.2246 74.4776 10.5674L75.0946 4.07956C73.7319 3.59961 71.9493 3.25679 69.7038 3.25679C66.8327 3.25679 63.4902 4.14812 61.0305 6.47073Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0946 3.25679H52.4943V52.4943H75.0946V3.25679Z",
    fill: "url(#paint2_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 18,
    width: 50,
    height: 35
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.802 20.2521C141.216 21.212 139.845 22.5918 138.671 24.4516H138.533C137.085 20.732 133.648 18.2551 129.243 18.2551C123.604 18.2551 120.57 21.3491 118.916 23.9717H118.71L118.573 21.949C118.461 20.2949 117.082 19.0179 115.427 19.0179H111.074C111.279 21.9062 111.348 25.1458 111.348 29.0025V52.5457H119.61V32.7221C119.61 31.7622 119.747 30.7938 120.09 29.971C120.844 27.6313 122.978 25.1544 126.149 25.1544C130.074 25.1544 131.934 28.4626 131.934 33.1421V52.5543H140.196V32.4565C140.196 31.4966 140.402 30.4595 140.608 29.6368C141.499 27.2285 143.633 25.163 146.53 25.163C150.592 25.163 152.521 28.4712 152.521 34.042V52.5628H160.782V32.8078C160.782 22.069 155.134 18.2809 149.564 18.2809C146.813 18.2809 144.678 18.9665 142.819 20.2778",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.771 18.2551H111.07V52.5371H160.771V18.2551Z",
    fill: "url(#paint3_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 18,
    width: 29,
    height: 36
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.401 42.4154C174.401 37.316 180.118 36.0132 186.1 36.1504V40.7613C186.1 41.3098 186.031 42.004 185.826 42.6211C185.071 45.0294 182.594 47.232 179.218 47.232C176.535 47.232 174.401 45.7151 174.401 42.4154ZM168.41 21.212L170.064 26.7142C172.336 25.2658 175.781 24.2374 179.081 24.2374C185.003 24.2374 185.894 27.8884 185.894 30.091V30.6395C173.501 30.571 166.002 34.8391 166.002 43.3067C166.002 48.3976 169.79 53.2914 176.535 53.2914C180.872 53.2914 184.386 51.4316 186.451 48.8176H186.657L187.205 52.5372H194.85C194.507 50.4717 194.37 47.5149 194.37 44.4809V32.3622C194.37 25.0687 191.268 18.2551 180.538 18.2551C175.232 18.2551 170.896 19.7036 168.419 21.212",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.842 18.2551H166.002V53.2914H194.842V18.2551Z",
    fill: "url(#paint4_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 201,
    y: 18,
    width: 32,
    height: 35
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.72 24.0402H209.514L209.343 21.9062C209.206 20.2692 207.843 19.0179 206.206 19.0179H201.672C201.878 21.9062 201.947 25.1458 201.947 29.0026V52.5457H210.483V32.8593C210.483 31.8994 210.551 30.8624 210.826 30.1082C211.717 27.5627 214.065 25.1544 217.434 25.1544C222.044 25.1544 223.836 28.8054 223.836 33.6221V52.5543H232.303V32.6622C232.303 22.0605 226.244 18.2809 220.39 18.2809C214.537 18.2809 211.168 21.4434 209.72 24.066",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.295 18.2552H201.664V52.5372H232.295V18.2552Z",
    fill: "url(#paint5_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 237,
    y: 18,
    width: 30,
    height: 36
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M245.999 42.4154C245.999 37.316 251.716 36.0132 257.706 36.1504V40.7613C257.706 41.3098 257.638 42.004 257.432 42.6211C256.669 45.0294 254.192 47.232 250.824 47.232C248.142 47.232 246.008 45.7151 246.008 42.4154M240.017 21.212L241.671 26.7142C243.942 25.2658 247.387 24.2374 250.687 24.2374C256.609 24.2374 257.501 27.8884 257.501 30.091V30.6395C245.108 30.571 237.609 34.8391 237.609 43.3067C237.609 48.3976 241.397 53.2914 248.142 53.2914C252.478 53.2914 255.992 51.4316 258.058 48.8176H258.263L258.812 52.5372H266.457C266.114 50.4717 265.977 47.5149 265.977 44.4809V32.3622C265.977 25.0687 262.883 18.2551 252.144 18.2551C246.848 18.2551 242.502 19.7036 240.025 21.212",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.445 18.2551H237.605V53.2914H266.445V18.2551Z",
    fill: "url(#paint6_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 269,
    y: 19,
    width: 34,
    height: 34
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M296.016 19.0179C294.636 19.0179 293.419 19.9178 293.008 21.2291L288.397 36.0218C287.497 39.0472 286.743 41.6697 286.126 44.4209H285.92C285.303 41.6697 284.609 38.9872 283.649 36.0218L278.91 21.212C278.49 19.9092 277.281 19.0179 275.91 19.0179H269.053L281.515 52.5371H289.845L302.65 19.0179H296.016Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.645 19.0179H269.057V52.5371H302.645V19.0179Z",
    fill: "url(#paint7_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 315,
    height: 54
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M315 0H0V53.2914H315V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.526 11.3645C313.526 14.707 310.903 17.3296 307.492 17.3296C304.081 17.3296 301.416 14.707 301.416 11.3645C301.416 8.022 304.115 5.46799 307.492 5.46799C310.869 5.46799 313.526 8.09056 313.526 11.3645ZM302.924 11.3645C302.924 13.9871 304.861 16.0697 307.527 16.0697C310.192 16.0697 312.017 13.9871 312.017 11.3988C312.017 8.81048 310.115 6.65929 307.492 6.65929C304.87 6.65929 302.924 8.7762 302.924 11.3645ZM306.549 14.4584H305.187V8.56194C305.727 8.45052 306.481 8.38196 307.449 8.38196C308.564 8.38196 309.069 8.56194 309.498 8.81048C309.823 9.05903 310.072 9.5304 310.072 10.1046C310.072 10.7474 309.566 11.2531 308.846 11.4673V11.5359C309.421 11.7502 309.746 12.1787 309.926 12.9757C310.106 13.8756 310.209 14.2356 310.355 14.4499H308.881C308.701 14.2356 308.598 13.6957 308.418 13.01C308.306 12.3672 307.955 12.0758 307.192 12.0758H306.549V14.4499V14.4584ZM306.584 11.1159H307.227C307.981 11.1159 308.589 10.8674 308.589 10.2503C308.589 9.71038 308.195 9.35042 307.329 9.35042C306.969 9.35042 306.721 9.3847 306.575 9.41899V11.1074L306.584 11.1159Z",
    fill: "#231F20"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 18,
    width: 20,
    height: 10
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1331 18.6837L88.7045 18.7351C88.3017 18.8037 87.5475 18.9236 87.0076 19.2579C83.9479 21.152 91.8928 26.08 100.283 27.4856C106.617 28.5483 105.168 26.5343 104.689 25.8658C104.68 25.8572 103.84 24.6916 103.403 24.563C101.852 26.5085 90.4872 22.7461 89.5873 19.995C89.1073 18.5294 93.0926 17.7838 98.672 20.4063C98.4492 20.2949 98.1492 20.1492 97.9178 20.0464C97.7464 19.9664 97.4893 19.8578 97.1465 19.7207C96.9865 19.6579 96.7465 19.5693 96.4266 19.455C96.2723 19.4036 96.0409 19.3322 95.7323 19.2408C95.5781 19.195 95.341 19.1322 95.021 19.0522C94.7725 18.9922 94.7553 18.9922 94.2668 18.8894C94.0782 18.8494 93.7926 18.8008 93.4097 18.7437C92.4841 18.6237 91.7556 18.5808 91.0614 18.5808C90.4272 18.5808 89.8273 18.6237 89.1331 18.6837Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.6182 11.8484L81.1218 27.7488L104.931 34.4816L109.428 18.5813L85.6182 11.8484Z",
    fill: "url(#paint8_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 21,
    width: 30,
    height: 16
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1197 21.8119C80.5712 22.2404 79.8684 22.8404 79.3542 23.2946C78.12 24.5116 78.7885 26.2857 81.2226 28.2998C84.8307 31.2909 91.9357 34.3591 98.4921 35.7733C108.1 37.8388 107.92 35.5419 107.791 34.0249C107.697 32.8507 107.594 32.6536 107.465 32.3879C106.951 33.365 104.32 33.5364 100.429 32.8593C89.6731 30.9738 77.8115 24.2117 82.191 21.1006C81.8653 21.3063 81.4454 21.5977 81.1283 21.8205",
    fill: "white"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0437 13.1595L73.4135 36.606L105.849 45.7783L112.48 22.3318L80.0437 13.1595Z",
    fill: "url(#paint9_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 28,
    width: 33,
    height: 18
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8718 30.7852L74.5719 32.0108C74.5633 32.1051 74.5376 32.2422 74.529 32.3365C74.4347 35.4304 80.6826 39.3557 86.5277 41.6783C95.8352 45.3894 103.66 46.1521 105.126 44.5323C105.443 44.0267 105.828 43.3239 106.111 42.8011C106.308 42.4154 106.523 41.8669 106.694 41.4641C106.557 41.7469 106.343 41.8755 106.231 41.944C101.295 44.8751 73.4491 35.5419 75.6946 28.4969C75.4203 29.1654 75.0947 30.0825 74.8633 30.7767",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.9083 19.787L68.8232 44.8417L104.236 54.8559L111.321 29.8012L75.9083 19.787Z",
    fill: "url(#paint10_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 38,
    width: 28,
    height: 13
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8633 39.9642C75.0347 40.5213 75.3004 41.2498 75.4975 41.7898C77.6059 46.5978 93.7098 52.2286 98.0894 50.6259L98.4236 50.4717C99.3835 49.9917 99.4864 49.9232 100.806 49.049L101.003 48.9033C97.3437 51.2344 76.3117 44.8751 74.4862 38.3873C74.5805 38.8672 74.7433 39.5014 74.8547 39.9728",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.45 31.4382L70.8599 51.2065L99.0402 59.1754L104.63 39.4071L76.45 31.4382Z",
    fill: "url(#paint11_linear_16_194)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_16_194",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 47,
    width: 13,
    height: 6
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8798 48.7661C81.3769 49.1346 81.454 49.1861 82.2168 49.6831C82.5853 49.906 82.6111 49.9231 83.271 50.2831L83.3995 50.3516C85.1222 51.2258 86.6649 51.6115 87.1706 51.7401C87.3591 51.7829 87.6077 51.8343 87.7962 51.8772C87.9848 51.9115 88.2704 51.96 88.6533 52.0229C90.016 52.22 91.2158 52.1857 91.8586 52.1686C88.4561 52.1857 82.1911 50.0774 79.2257 47.3434C79.8514 47.9519 79.9713 48.0462 80.8798 48.7747",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_16_194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1575 44.0166L77.9443 51.8431L90.9253 55.5139L93.1385 47.6874L80.1575 44.0166Z",
    fill: "url(#paint12_linear_16_194)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_194",
    x1: 0.231403,
    y1: 30.1167,
    x2: 105.649,
    y2: 30.1167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DC3E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16_194",
    x1: 0.231375,
    y1: 36.1194,
    x2: 105.648,
    y2: 36.1194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DC3E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16_194",
    x1: 0.231429,
    y1: 28.5141,
    x2: 105.648,
    y2: 28.5141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DC3E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16_194",
    x1: 290.408,
    y1: 34.7486,
    x2: 115.073,
    y2: 34.7486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#501E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#89123E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16_194",
    x1: 290.403,
    y1: 35.1257,
    x2: 115.068,
    y2: 35.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#501E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#89123E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16_194",
    x1: 290.403,
    y1: -10867.6,
    x2: 115.068,
    y2: -10867.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#501E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#89123E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16_194",
    x1: 290.408,
    y1: 35.1257,
    x2: 115.073,
    y2: 35.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#501E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#89123E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16_194",
    x1: 290.397,
    y1: 35.1257,
    x2: 115.062,
    y2: 35.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1F2760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#501E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#89123E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16_194",
    x1: -22.3572,
    y1: -9.91225,
    x2: 79.082,
    y2: 18.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DC3E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_16_194",
    x1: -24.2335,
    y1: -3.25351,
    x2: 77.2057,
    y2: 25.4318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DC3E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_16_194",
    x1: -26.4131,
    y1: 4.4259,
    x2: 75.0262,
    y2: 33.1112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DC3E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_16_194",
    x1: -28.6586,
    y1: 12.3586,
    x2: 72.7807,
    y2: 41.0439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DC3E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_16_194",
    x1: -29.9909,
    y1: 17.0902,
    x2: 71.4483,
    y2: 45.7755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E5681F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DC3E20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C52329"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfomanav);
export default __webpack_public_path__ + "static/media/Infomanav.fbf36f80bca56bc2570f00ff1debf7d5.svg";
export { ForwardRef as ReactComponent };